module.exports = __webpack_public_path__ + "static/grid_responsive-d80e34d86afc8ca8022e53a7f33f4f34.webm";